/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Modal, ModalProps } from 'react-bootstrap';
import PaymentMethodsForm, { PaymentMethod } from './PaymentMethodsForm';

interface PaymentModalProps extends ModalProps {
  totalAmount?: number;
  maxInstallments?: number;
  invoiceNumber?: string;
  allowedMethods?: PaymentMethod[];
  onPaymentSubmit?: (data: any) => void | Promise<void>;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
  totalAmount = 10000,
  maxInstallments = 12,
  invoiceNumber = 'NF-2024-001',
  allowedMethods,
  onPaymentSubmit,
  ...modalProps
}) => {
  const handleFormSubmit = (data: any) => {
    if (onPaymentSubmit) {
      return onPaymentSubmit(data);
    }
    return undefined;
  };

  return (
    <Modal {...modalProps} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Pagamento - {invoiceNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PaymentMethodsForm
          totalAmount={totalAmount}
          maxInstallments={maxInstallments}
          allowedMethods={allowedMethods}
          onSubmit={handleFormSubmit}
        />
      </Modal.Body>
    </Modal>
  );
};

export default PaymentModal;
